import {
  ErrorBoundary,
  ModalContainer,
  ThemeProvider,
  useTheme
} from '@convergence/components';
import '@convergence/components/dist/components.css';
import { QueryClientProvider } from '@tanstack/react-query';
import { PostHogProvider } from 'posthog-js/react';
import { ToastContainer } from 'react-toastify';
import { queryClient } from '../api/query-client';
import { AuthProvider } from '../components/AuthProvider';
import { PopoverProvider } from '../components/Popover';

const ToastContainerWrapper = () => {
  const theme = useTheme();

  return <ToastContainer theme={theme.darkMode ? 'dark' : 'light'} />;
};

function PostHogWrapper(props: { children: React.ReactNode }) {
  const prod = import.meta.env.PROD;
  if (!prod) {
    return <>{props.children}</>;
  }
  return (
    <PostHogProvider
      apiKey={import.meta.env.VITE_POSTHOG_KEY}
      options={{
        api_host: import.meta.env.VITE_POSTHOG_HOST
      }}
    >
      {props.children}
    </PostHogProvider>
  );
}
export function Providers(props: { children: React.ReactNode }) {
  return (
    <PostHogWrapper>
      <ErrorBoundary>
        <ModalContainer>
          <QueryClientProvider client={queryClient}>
            <AuthProvider>
              <ThemeProvider>
                <PopoverProvider>{props.children}</PopoverProvider>
              </ThemeProvider>
            </AuthProvider>
          </QueryClientProvider>
        </ModalContainer>
        <ToastContainerWrapper />
      </ErrorBoundary>
    </PostHogWrapper>
  );
}
